module.exports = __webpack_public_path__ + "static/media/based-xxxswap-logo-transparent.931ca0d2.png";